import React, { useState, useCallback, useMemo } from "react";
import { Outlet, useLocation } from "react-router-dom";
import PatientSidebar from "./PatientSidebar";
import { useTheme } from "../context/ThemeContext";
import { motion, AnimatePresence } from "framer-motion";
import "../Styles/patientsidebar.css";

const PatientLayout = () => {
  const { theme, isDarkMode } = useTheme();
  const [completedSections, setCompletedSections] = useState({});
  const location = useLocation();

  const markSectionComplete = useCallback((sectionId) => {
    setCompletedSections((prev) => ({
      ...prev,
      [sectionId]: true,
    }));
  }, []);

  const contextValue = useMemo(() => ({ markSectionComplete }), [markSectionComplete]);

  return (
    <div
      className="min-h-screen w-full transition-colors duration-700 ease-in-out flex items-center justify-center p-2 md:p-8 lg:p-12"
      style={{
        color: theme.text
      }}
    >
      <div
        className="w-full max-w-7xl h-full min-h-[95vh] md:min-h-0 md:h-[92vh] max-h-none md:max-h-[92vh] rounded-3xl md:rounded-[2.5rem] shadow-2xl flex flex-col md:flex-row overflow-hidden border"
        style={{
          backgroundColor: theme.card,
          borderColor: theme.border
        }}
      >
        {/* Sidebar wrapper */}
        <aside
          className="w-full md:w-80 lg:w-96 border-b md:border-b-0 md:border-r flex-shrink-0 h-auto md:h-full"
          style={{ borderColor: theme.border, backgroundColor: isDarkMode ? "rgba(0,0,0,0.2)" : "rgba(0,0,0,0.02)" }}
        >
          <div className="h-full overflow-y-auto md:overflow-visible">
            <PatientSidebar completedSections={completedSections} />
          </div>
        </aside>

        {/* Content area */}
        <main className="flex-1 overflow-y-auto relative p-4 md:p-10 lg:p-12 scroll-smooth">
          <AnimatePresence mode="wait" initial={false}>
            <motion.div
              key={location.pathname}
              initial={{ opacity: 0, x: 10 }}
              animate={{ opacity: 1, x: 0 }}
              exit={{ opacity: 0, x: -10 }}
              transition={{ duration: 0.3, ease: "easeOut" }}
              className="h-full"
            >
              <Outlet context={contextValue} />
            </motion.div>
          </AnimatePresence>
        </main>
      </div>
    </div>
  );
};

export default PatientLayout;
